import { Alert } from "react-bootstrap";
import AdminCartCard from "../../../components-admin/AdminCartCard/AdminCartCard";
import LoadingMask from "../../../components/LoadingMask/LoadingMask";
import { useAdminRecentCarts } from "../../../hooks/use-admin-recent-carts";
import { useAppAuthState } from "../../../hooks/use-app-auth-state";
import { useDocumentTitle } from "../../../hooks/use-document-title";
import { useRedirectIfNotAdmin } from "../../../hooks/use-redirect-if-not-admin";
import { Cart } from "../../../types/Cart";

const AdminCartsPage: React.FC = () => {
  useDocumentTitle("Carts | Admin");
  useRedirectIfNotAdmin();

  const { fireUser, isAuthLoading, isUserAdmin } = useAppAuthState();
  const { carts, cartUserMap, isLoading, error } = useAdminRecentCarts();

  if (error) {
    return (
      <div className="admin-carts-home-page">
        <div className="page-header">Carts</div>
        <Alert variant="danger">{error}</Alert>
      </div>
    );
  }

  if (isAuthLoading || !isUserAdmin || !fireUser) {
    return <LoadingMask message="Loading admin page..." />;
  }

  if (isLoading) {
    return <LoadingMask message="Loading carts..." />;
  }

  return (
    <div className="admin-carts-home-page">
      <div className="page-header">Carts</div>
      <div className="results-section">
        {carts.map((cart: Cart) => (
          <AdminCartCard
            key={cart.id}
            cart={cart}
            user={
              cart.creatorUserId
                ? (cartUserMap.get(cart.creatorUserId) ?? null)
                : null
            }
          />
        ))}
        {carts.length === 0 && <Alert variant="info">No carts found</Alert>}
      </div>
    </div>
  );
};

export default AdminCartsPage;
